<!--suppress XmlDuplicatedId -->
<ng-container *ngrxLet="vm$ as vm">
  @if (vm.loading) {
    <full-page-spinner></full-page-spinner>
  }
  @if (!vm.loading) {
    <se-fe-page
      [seFeDataLoaded]="true"
      SeFeDataWidth="full"
      [seFeDataBackLink]="vm.backLink.backLink"
      [seFeDataBackQueryParams]="vm.backLink.backLinkParams"
      seFeDataBackText="Back"
      class="se-product-management product-detail"
      id="se-product-management">
      <div seFePageHeader>
        <se-fe-header [seFeDataTitle]="vm.product?.name ?? ''" size="750"></se-fe-header>
      </div>
      <div seFePageContent>
        @if (vm.product?.active === false && vm.syncedWithClare === true) {
          <se-fe-alert seFeDataType="warning">
            Product bundle is inactive
            <se-fe-alert-subheader>
              Set the status to Active to make this bundle available to be sold in registrations.
            </se-fe-alert-subheader>
          </se-fe-alert>
        }
        <se-fe-grid>
          <se-fe-grid-cell id="product-detail__wide-cards" seFeGridOpts="1/3">
            <se-fe-grid seFeGridOpts="justified">
              <se-fe-grid-cell seFeGridOpts="1/3">
                <bundle-details-card
                  [bundle]="vm.bundle"
                  [error]="vm.error"
                  (updateProductAndPriceBreak)="updateProductAndPriceBreak($event)"></bundle-details-card>
              </se-fe-grid-cell>
            </se-fe-grid>
            <se-fe-grid seFeGridOpts="justified">
              <se-fe-grid-cell seFeGridOpts="1/3">
                <included-products-card
                  [bundle]="vm.bundle"
                  [error]="vm.error"
                  mode="edit"
                  [products]="bundleProducts"
                  [loading]="false"
                  (productsSelected)="handleProductsSelected($event)"
                  (setAllProductsToActive)="setAllProductsToActive()"
                  [ineligibleProducts]="vm.ineligibleProducts"
                  (productRemoved)="handleProductRemoved($event)"></included-products-card>
              </se-fe-grid-cell>
            </se-fe-grid>
            <se-fe-grid seFeGridOpts="justified">
              <se-fe-grid-cell seFeGridOpts="1/3">
                <item-media-card
                  [product]="vm.product"
                  [error]="vm.error"
                  [image]="vm.image"
                  [images]="vm.images"
                  [allowMultipleImages]="true"
                  (updateProductImageAndDescription)="updateProductImageAndDescription($event)"
                  (setError)="setError($event)"></item-media-card>
              </se-fe-grid-cell>
            </se-fe-grid>
          </se-fe-grid-cell>
          <se-fe-grid-cell id="product-detail__snug-cards" seFeGridOpts="1/4">
            <se-fe-grid id="product-detail__product-status" seFeGridOpts="snug">
              <se-fe-grid-cell seFeGridOpts>
                <se-fe-card>
                  <se-fe-card-header
                    seFeDataTitle="Product bundle status"
                    [seFeDataHeavyBorder]="true"></se-fe-card-header>
                  <se-fe-card-content>
                    <span [seFeMenuTrigger]="attrMenu">
                      <se-fe-chip
                        [seFeMenuTrigger]="attrMenu"
                        [seFeDataText]="getStatusChipText(!!vm.product?.active)"
                        [seFeDataStyle]="getStatusChipStyle(!!vm.product?.active, vm.syncedWithClare)"
                        [seFeDataDisabled]="
                          (vm.statusUpdating ?? false) || (!vm.canActivateBundle && !vm.product?.active)
                        "
                        [seFeDataFocusableOnDisabled]="true"
                        seFeDataIconLeft="dot_fill"
                        seFeMenuTriggerElement></se-fe-chip>
                    </span>
                    @if (!vm.canActivateBundle && !vm.product?.active) {
                      <se-fe-form-control-help>
                        Bundles need a name, two or more products, and no inactive products to be active.
                      </se-fe-form-control-help>
                    }
                    <se-fe-menu #attrMenu [seFeDataOptions]="bundleStatusMenuOptions"></se-fe-menu>
                  </se-fe-card-content>
                </se-fe-card>
              </se-fe-grid-cell>
            </se-fe-grid>
            <se-fe-grid seFeGridOpts="snug">
              <se-fe-grid-cell id="product-detail__snug-cards" seFeGridOpts>
                <item-org-card
                  cardTitle="Product bundle organization"
                  [editable]="true"
                  [catalogsOnly]="true"
                  [brandName]="vm.brandName"
                  [vendorName]="vm.vendorName"
                  [products]="bundleProducts"
                  [catalogs]="vm.catalogs"
                  [catalogsLoading]="vm.catalogsLoading"
                  [organizationCatalogs]="vm.organizationCatalogs"
                  [organizationCatalogsLoading]="vm.organizationCatalogsLoading"
                  [organizationId]="vm.organizationId"
                  (organizationCatalogsRequested)="loadOrganizationCatalogs()"
                  (updateProductBrand)="saveBundleCatalogs($event)"></item-org-card>
              </se-fe-grid-cell>
            </se-fe-grid>
          </se-fe-grid-cell>
        </se-fe-grid>
      </div>
    </se-fe-page>
  }
</ng-container>
